import { render, staticRenderFns } from "./RestaurantOrderList.vue?vue&type=template&id=502f65a0&"
import script from "./RestaurantOrderList.vue?vue&type=script&lang=js&"
export * from "./RestaurantOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports